import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=425ca2a7"
import script from "./competition.vue?vue&type=script&lang=js"
export * from "./competition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports